<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">充值记录</span>
  </a-card>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}"  layout='inline'>
      <a-form-item label="订单号" name='order_no'>
        <a-input style='width:270px' v-model:value="search.order_no" placeholder="请输入订单号进行搜索" />
      </a-form-item>
      <a-form-item label="创建日期" name='time' >
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item label="支付类型" name='pay_type' >
        <a-select v-model:value="search.pay_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">扫码支付</a-select-option>
          <a-select-option :value="2">余额支付</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="订单状态" name='order_status' >
        <a-select v-model:value="search.order_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">已下单</a-select-option>
          <a-select-option value="2">已完成</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch" >搜索</a-button>
      </a-form-item>
    </a-form>
    <div class="fz-16 m-b-20 s_font_b"><span>总花费:</span> <span class='s_cd41'>{{totalMoney || 0}}元</span>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='order_no' :columns='columns' :data-source='data' >
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                 <span  @click="getMore(record.order_no)">详情</span>
              </a-menu-item>
              <a-menu-item v-if="record.pay_time==0">
                  <span  @click="$router.push({path:'/messageCenter/sms/playDetail',query:{order_no:record.order_no}})">支付</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
     <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
  </a-card>
  <a-modal  :keyboard="false" title="记录详情" centered v-model:visible="moreShow" :footer='null' @cancel="moreShow=false" destroyOnClose>
    <a-descriptions :column='1'>
      <a-descriptions-item label="订单号">{{orderDetail.order_no}}</a-descriptions-item>
      <a-descriptions-item label="订单状态">{{orderDetail.order_status==1?'已下单':'已完成'}}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{orderDetail.create_time}}</a-descriptions-item>
      <a-descriptions-item label="充值金额">{{orderDetail.amount}}</a-descriptions-item>
      <a-descriptions-item label="充值条数">{{orderDetail.strip}}</a-descriptions-item>
      <a-descriptions-item label="支付类型">{{orderDetail.pay_type==0?'未支付':orderDetail.pay_type==1?'扫码支付':orderDetail.pay_type==2?'余额支付':'线下支付'}}</a-descriptions-item>
      <a-descriptions-item label="支付时间">{{orderDetail.pay_time==0?'--':orderDetail.pay_time}}</a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import { ref } from "vue";
import {getSmsOrder,getSmstotal,getSmsOrderDetail } from '@/api/message'
import { DownOutlined,LeftOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';
const def={
  order_no:'',
  start:"",
  end:'',
  pay_status:"",
  check_status:"",
  pay_type:"",
  sms_package_id:"",
  page:1,
  limit:10,
  order_status:""
}
export default {
  components: { DownOutlined,LeftOutlined },
  setup() {
    const search = ref({...def});
    const data = ref([]);
    const total=ref(0)
    const listLoading = ref(false);
    const open = ref(false);
    const moreShow = ref(false);
    const orderDetail = ref({})
    let columns = [
      {
        title: "订单号",
        dataIndex: "order_no",
        key: "order_no",
      },
      {
        title: "充值金额(元)",
        dataIndex: "amount",
        key: "amount",
      },
       {
        title: "充值条数(条)",
        dataIndex: "strip",
        key: "strip",
      },
       {
        title: "支付时间",
        dataIndex: "pay_time",
        key: "pay_time",
         customRender:({record})=>{
          if(record.pay_time==0){
            return '-'
          }else{
            return record.pay_time
          }
        } 
      },
       {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
       {
        title: "支付类型",
        dataIndex: "pay_type",
        key: "pay_type",
        customRender:({record})=>{
          if(record.pay_type==0){
            return '未支付'
          }else{
            return record.pay_type==1?'扫码支付':record.pay_type==2?'余额支付':'线下支付'
          }
        } 
      },
       {
        title: "订单状态",
        dataIndex: "order_status",
        key: "order_status",
          customRender:({record})=>{
              return record.order_status==1?'已下单':'已完成'
        } 
      },
       {
        title: "审核状态",
        dataIndex: "check_status",
        key: "check_status",
         customRender:({record})=>{
          if(record.check_status==3){
            return '-'
          }else{
            return  record.check_status==0?'审核中':record.check_status==1?'审核通过':'审核失败'
          }
        } 
      },
       {
        title: "操作人",
        dataIndex: "account",
        key: "account"
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const onSearch=()=>{
      search.value.page=1
      initData(search.value)
    }
    //获取详情
    const getMore = async (order_no) => {
      const hide = message.loading("正在加载中...", 0);
      let result = await getSmsOrderDetail({ order_no:order_no }).then(res => res.data).catch(error => error)
      if (iscode(result)) {
        orderDetail.value = result.data
        moreShow.value = true
      }
      setTimeout(hide);
    };
    // 初始化数据
    const initData=async(values)=>{
      listLoading.value=true
      let result =await getSmsOrder(values).then(res=>res.data).catch(error=>error)
      listLoading.value=false
      data.value=result.data.data
      total.value=result.data.total
    }
    initData(search.value)
    var totalMoney=ref(0)
    var getTotal=async ()=>{
     let result =await getSmstotal().then(res=>res.data).catch(error=>error)
      totalMoney.value=result.data.total
    }
    getTotal()
      // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    }
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    }
    // 时间筛选
    const onChange = (e) => {
      search.value.start = e[0]
      search.value.end = e[1]
      initData(search.value)
    }
    return {
      search,
      columns,
      data,
      open,
      onChange,
      onSearch,
      total,
      pageSizeChange,
      pageCurrentChange,
      listLoading,
      totalMoney,
      moreShow,
      orderDetail,
      getMore
    };
  },
};
</script>